import { datadogRum } from '@datadog/browser-rum'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { API_ERROR_TYPES } from '@hooks-api/types/api-error-type'
import { ThemeProvider } from '@pets-ui/ThemeProvider/ThemeProvider'
import { useEffect } from 'react'
import { AuthRoutes } from './AuthRoutes'
import { colorThemeMap, fastpassColorTheme } from './constants'
import { useCountryCode, useStmBrandStore } from './hooks'
import { UnauthRoutes } from './UnauthRoutes'

export const StmRouters = () => {
  const siteCountryCode = useCountryCode()
  const { currentBrand, brands, countryCode: storedCountryCode } = useStmBrandStore()
  const colorTheme = (currentBrand && colorThemeMap[currentBrand.projectCode]) || fastpassColorTheme
  const { destructuredData: campaignMember } = useApiCampaignMember(currentBrand ? { code: currentBrand.campaignCode } : undefined, {
    shouldRetryOnError: (error) => {
      if (error?.response?.data.error?.type === API_ERROR_TYPES.AUTHENTICATION_ERROR) {
        return false
      }
      return true
    },
  })

  useEffect(function identifyDatadogUser() {
    if (campaignMember) {
      datadogRum.setUser({
        id: campaignMember.platform_uid,
        name: campaignMember.user_name,
        email: campaignMember.account,
        project_code: campaignMember.project_code,
        roles: campaignMember.roles,
      })
    }
  }, [campaignMember])

  /**
   * 進入 AuthRoutes 的條件：
   * 1. store 內有可用品牌
   * 2. store 紀錄的 country 跟當前 URL 的 country 一致
   * 不一致時 StmRouters 會視為未登入並走 UnauthRoutes，避免跨國資料污染
   */
  const hasAuthorizedBrands = brands.length > 0 && storedCountryCode === siteCountryCode

  return (
    <ThemeProvider theme={colorTheme}>
      {hasAuthorizedBrands ? <AuthRoutes /> : <UnauthRoutes />}
    </ThemeProvider>
  )
}
